function stackDebounce(fn, debouncer) {
  var this$1 = this;

  var queue = [];
  var lastPromise;
  var waiting = false;
  var resolver = function () { return new Promise(function ($return, $error) {
    if (!waiting) {
      waiting = true;
      return Promise.resolve(debouncer(lastPromise)).then(function ($await_2) {
        try {
          waiting = false;
          if (queue.length) {
            lastPromise = queue.pop()();
            queue = [];
          }
          return $If_1.call(this);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    }

    function $If_1() {
      return $return();
    }

    return $If_1.call(this);
  }.bind(this$1)); };
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    queue.push(function () { return fn.apply(void 0, args); });
    return resolver();
  };
}

export default stackDebounce;
